export default __webpack_public_path__ + "static/ProValue_1-78827f1d0300af96d1273dba8d45dd85.png";